import {
  ApiPostEmployeeAbsence,
  ApiPutEmployeeAbsence,
  ViewEmployeeAbsence,
} from '@xeetr/types/models'

import ApiService from './common/API.service'


export class EmployeeAbsenceService extends ApiService {
  postEmployeeAbsence = async (data: ApiPostEmployeeAbsence): Promise<ViewEmployeeAbsence> => {
    const { data: response } = await this.post<ApiPostEmployeeAbsence, ViewEmployeeAbsence>(
      this.buildTenantUrl('employee/absence'),
      data
    )
    return response
  }

  putEmployeeAbsence = async (data: ApiPutEmployeeAbsence): Promise<ViewEmployeeAbsence> => {
    const { data: response } = await this.put<ApiPutEmployeeAbsence, ViewEmployeeAbsence>(
      this.buildTenantUrl('employee/absence'),
      data
    )
    return response
  }

  getEmployeeAbsence = async (id: string): Promise<ViewEmployeeAbsence> => {
    const { data } = await this.get<ViewEmployeeAbsence>(this.buildTenantUrl('employee/absence'), {
      params: { id },
    })
    return data
  }

  deleteEmployeeAbsence = async (id: string): Promise<void> => {
    await this.delete(this.buildTenantUrl('employee/absence'), {
      params: { id },
    })
  }
}
